import React, { createContext, useContext, useRef } from "react";
import { useAuth } from "@/AuthContext";
import { usePerms } from "@/PermissionContext";

const PlanningDraftContext = createContext(null);

/**
 * Session memory above responsive Layout branches. Never browser storage:
 * private local edits survive a layout remount, not logout/account changes.
 */
export function PlanningDraftSessionProvider({ children }) {
  const { user } = useAuth();
  const { can } = usePerms();
  const owner = user && can("production_planning", "manage")
    ? `${user.tenant_id || ""}|${user.id || user._id || ""}` : "";
  const session = useRef({ owner, value: null });
  if (session.current.owner !== owner) session.current = { owner, value: null };
  return <PlanningDraftContext.Provider value={session}>{children}</PlanningDraftContext.Provider>;
}

export function usePlanningDraftSession() {
  return useContext(PlanningDraftContext);
}

export function cachePlanningDraft(session, owner, value) {
  // A previous account's page can commit an effect just as auth is changing.
  // It must never populate the next account's freshly cleared session.
  if (session?.current.owner === owner) session.current.value = value;
}
